module.exports = __webpack_public_path__ + "static/img/oyin.eaf2644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oyin.png
// module id = iB4K
// module chunks = 0